import React from "react";
import {
  RemoveSupplyFormContent,
  RemoveSupplyFormContentProps,
} from "src/components/Form/RemoveSupply";

export const ContentSection = (props: RemoveSupplyFormContentProps) => (
  <RemoveSupplyFormContent {...props} />
);
